module.exports = __webpack_public_path__ + "static/media/retirement-object-1-1-1.cb291939.svg";